(function() {
  'use strict';

  angular
    .module('spo-web-catalog', ['ngRoute']);

})();

(function() {
  'use strict';

  angular
    .module('spo-web-catalog')
    .service('TranslationService', TranslationService);

  /** @ngInject */
  function TranslationService($http, $timeout, $log, $q) {
    var self = this;
    var configUrl = 'app/config.json';
    self.config = '';
    self.language = 'fr';

    //Load translation file
    self.loadConfig = function() {
      var deferred = $q.defer();

      $http.get(configUrl)
        .success(function(data) {
          //Load all config key
          $log.debug('TRANSLATE - Translation config file loaded !');
          self.config = data;
          deferred.resolve();
          // $rootScope.ready = true;
          // $rootScope.$emit('ready');
        })
        .error(function(data, status, header, config) {
          $log.error('Error on reading config.json');
          deferred.reject(new Error('Error on reading config.json'));
        });

      return deferred.promise;
    };

    self.translate = function(id) {
      // If config string not found
      if(!self.config.translations[id]) {
        $log.warn('Wrong config string %s', id);
        return;
      }

      // If no config string found
      if(!self.config.translations[id][self.language]) {
        $log.warn('No translation [%s] found for: %s', self.language, id);
        return;
      }

      return self.config.translations[id][self.language];

      // }
      // return message;
    };

    self.isLoaded = function() {
      return !angular.equals('', self.config) &&
        angular.isDefined(self.config.translations);
    };
  }


})();
(function() {
  'use strict';

  angular
    .module('spo-web-catalog')
    .service('RouteCheckService', RouteCheckService);

  /**
   * @ngInject */
  function RouteCheckService($q, $log, $location, RepositoryService) {
    var self = this;

    /** Public Methods **/

    self.checkUrl = function(routeParams) {
      $log.debug('Activate ApartmentController');

      var routeStatus = true; // True if route is ok

      if(angular.isDefined(routeParams.orbitalId)) {
        if(!self.checkOrbital(routeParams.orbitalId)) {
          routeStatus = false;
        }
      }

      if(angular.isDefined(routeParams.apartmentId)) {
        if(!self.checkApartment(routeParams.apartmentId)) {
          routeStatus = false;
        }
      }

      if(angular.isDefined(routeParams.panoramaId)) {
        if(!self.checkPanorama(routeParams.panoramaId)) {
          routeStatus = false;
        }
      }

      return routeStatus;
    };

    self.checkOrbital = function(orbitalId) {

    };

    self.checkApartment = function(apartmentId) {

    };

    self.checkPanorama = function(panoramaId) {

    };
  }

})();
(function() {
  'use strict';

  angular
    .module('spo-web-catalog')
    .service('IsMobileService', IsMobileService);

  /** @ngInject */
  function IsMobileService($window, $log) {
    var self = this;

    self.check = function() {
        var check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true;})(navigator.userAgent||navigator.vendor||$window.opera);
        return check;
    };
  }


})();
(function () {
    'use strict';

    angular
        .module('spo-web-catalog')
        .directive('checkImage', checkImage);

    /** @ngInject */
    function checkImage($http) {
        var directive = {
            restrict: 'A',
            link: function (scope, element, attrs) {
                attrs.$observe('ngSrc', function (ngSrc) {
                    if(angular.isDefined(ngSrc)) {
                        $http.get(ngSrc).success(function () {
                            //Nothing to do
                        }).error(function () {
                            //Png not find, return jpg
                            element.attr('src', ngSrc.replace(/.png$/g, ".jpg")); // set default image
                        });
                    }
                });
            }
        };

        return directive;

    }

})();

(function() {
  'use strict';

  angular
    .module('spo-web-catalog')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController($log) {
    $log.debug('HOMECTRL - -- HomeController --');

    /********* Déclarations initiales **********/

    var vm = this;

    // Catalog link
    vm.catalogUrl = 'http://catalogue.spo-pmo.com/catalog/index.html';

    // Setup chapters
    vm.chapters = [{
      id: 0, // id for translation
      page: 1, // Catalog page to redirect to
      icon: 'catalogue.jpg' // image to display
    }, {
      id: 1, // id for translation
      page: 3, // Catalog page to redirect to
      icon: 'couverture.jpg' // image to display
    }, {
      id: 2,
      page: 39,
      icon: 'supports_etancheite.jpg'
    }, {
      id: 3,
      page: 69,
      icon: 'bardages.jpg'
    }, {
      id: 7,
      page: 105,
      icon: 'arteface.jpg'
    }, {
      id: 4,
      page: 127,
      icon: 'accessoires_complements.jpg'
    }, {
      id: 5,
      page: 163,
      icon: 'cahiers_techniques.jpg'
    }, {
      id: 6,
      page: 245,
      icon: 'profiles_accessoires.jpg'
    }];
  }

})();

(function () {
    'use strict';

    angular
        .module('spo-web-catalog')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $log, TranslationService) {

      //
      // Global values
      //

      //
      // Global actions
      //

      // Load translation service and set translate method available everywhere
      $rootScope.translate = TranslationService.translate;

      $log.debug('runBlock end');
    }

})();

(function() {
  'use strict';

  angular
    .module('spo-web-catalog')
    .config(routeConfig);

  function routeConfig($routeProvider, $locationProvider) {
    $routeProvider
      .when('/', {
        templateUrl: 'app/home/home.html',
        controller: 'HomeController',
        controllerAs: 'vm',
        resolve: {
          translationService: function(TranslationService) { // Wait for config load before dopig anything
            return TranslationService.loadConfig();
          }
        }
      })
      .otherwise({
        redirectTo: '/'
      });

    $locationProvider.html5Mode(true);
  }

})();
(function () {
    'use strict';

    angular
        .module('spo-web-catalog');
    // .constant('REPOSITORYPATH', 'assets/repository/'); //Chemin des données


})();

(function() {
  'use strict';

  angular
    .module('spo-web-catalog')
    .config(config);

  /** @ngInject */
  function config($logProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

  }

})();
angular.module("spo-web-catalog").run(["$templateCache", function($templateCache) {$templateCache.put("app/home/home.html","<section class=\"container-fluid home\"><!-- <h2>Les catalogues</h2> --><div class=row><!-- Loop on chapters --><article class=\"col-sm-6 col-md-4\" ng-repeat=\"chapter in vm.chapters\"><a ng-href=\"{{vm.catalogUrl}}#p={{chapter.page}}\" class=chapter-container ng-class=\"\'chap\' + {{chapter.id}}\"><div class=\"thumbnail chapter\"><!-- <span>{{translate(\'homeChapter\'+ chapter.id +\'Title\')}}</span> --> <img ng-src=assets/images/{{chapter.icon}} ng-alt=\"{{translate(\'homeChapter\'+ chapter.id +\'Title\')}}\"><div class=caption><h4>> {{translate(\'homeChapter\'+ chapter.id +\'Title\')}}</h4></div></div></a></article></div></section>");}]);